import { render, staticRenderFns } from "./GoogleClassroomCoursePicker.vue?vue&type=template&id=da433aba&scoped=true&"
import script from "./GoogleClassroomCoursePicker.vue?vue&type=script&lang=ts&"
export * from "./GoogleClassroomCoursePicker.vue?vue&type=script&lang=ts&"
import style0 from "./GoogleClassroomCoursePicker.vue?vue&type=style&index=0&id=da433aba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da433aba",
  null
  
)

export default component.exports